import { getDataFromSqlJs } from "../offline/fetchHandlers";

export const getSrfsWithFullData = async () => {
  try {
    const srfs = await getDataFromSqlJs("SELECT * FROM srfs");
    const srfInstruments = await getDataFromSqlJs("SELECT * FROM srfInstruments");
    const datasheets = await getDataFromSqlJs("SELECT * FROM datasheets");
    const certificates = await getDataFromSqlJs("SELECT * FROM certificates");
    const datasheetStaticReadings = await getDataFromSqlJs("SELECT * FROM datasheetStaticReadings");


    const result = srfs.map((srf) => {
      
        const matchingInstruments = srfInstruments
        .filter((inst) => inst.srfsId == srf.id)
        .map((inst) => {
          const matchingCert = certificates.find((cert) => cert.id == inst.id);
          return {
            ...inst,
            ULRNo: matchingCert?.ULRNo || null, // Add ULRNo or null if not found
          };
        });

      const datasheetsData = datasheets.filter((sheet) =>
        matchingInstruments.some((inst) => inst.id == sheet.id)
      );

      const certificatesData = certificates.filter((cert) =>
        matchingInstruments.some((inst) => inst.id == cert.id)
      );

          const groupedDatasheetStaticReadingsData = matchingInstruments.map(inst => {
        const readingsForInst = datasheetStaticReadings.filter(
          reading => reading.datasheetId == inst.id
        );
        return readingsForInst;
      });


      return {
        srfsData: srf,
        srfInstrumentsData: matchingInstruments,
        datasheetsData,
        certificatesData,
        datasheetStaticReadingsData : groupedDatasheetStaticReadingsData,
      };
    });

    return result;
  } catch (error) {
    console.error("Error fetching complete SRF data:", error);
    return [];
  }
};